/**
 * Typed app errors for config/network flows (F19). No PII.
 */

export const APP_ERROR_CODES = {
  NETWORK_OFFLINE: 'NETWORK_OFFLINE',
  CONFIG_HTTP: 'CONFIG_HTTP',
  CONFIG_PARSE: 'CONFIG_PARSE',
  UNKNOWN: 'UNKNOWN',
};

/**
 * @param {{ code: string, message: string, cause?: unknown }} opts
 */
export function createAppError(opts) {
  const err = new Error(opts.message);
  err.code = opts.code;
  err.isAppError = true;
  if (opts.cause !== undefined) err.cause = opts.cause;
  return err;
}

/** User-facing Indonesian copy for config load failures. */
export function messageForConfigError(code) {
  switch (code) {
    case APP_ERROR_CODES.NETWORK_OFFLINE:
      return 'Tidak ada koneksi. Memakai pengaturan default.';
    case APP_ERROR_CODES.CONFIG_HTTP:
      return 'Gagal memuat konfigurasi (server). Memakai pengaturan default.';
    case APP_ERROR_CODES.CONFIG_PARSE:
      return 'Konfigurasi tidak valid. Memakai pengaturan default.';
    default:
      return 'Memakai pengaturan default.';
  }
}

/**
 * Map config.json fetch/parse failure to a typed error.
 * @param {unknown} caught
 * @param {Response | null} response
 */
export function mapConfigLoadError(caught, response) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return createAppError({
      code: APP_ERROR_CODES.NETWORK_OFFLINE,
      message: 'offline',
      cause: caught,
    });
  }
  if (response && !response.ok) {
    return createAppError({
      code: APP_ERROR_CODES.CONFIG_HTTP,
      message: `http ${response.status}`,
      cause: caught,
    });
  }
  if (caught instanceof SyntaxError) {
    return createAppError({
      code: APP_ERROR_CODES.CONFIG_PARSE,
      message: 'json parse',
      cause: caught,
    });
  }
  return createAppError({
    code: APP_ERROR_CODES.UNKNOWN,
    message: caught instanceof Error ? caught.message : 'unknown',
    cause: caught,
  });
}
